import { getSessionSnapshot } from '@/state/sessionSnapshot';

export const getCurrentUser = (): API.CurrentUser | null => {
  return (getSessionSnapshot().currentUser as API.CurrentUser | null) ?? null;
};

export const getCurrentMemberUuid = (): string | null => {
  return getCurrentUser()?.memberUuid ?? null;
};

export const requireCurrentMemberUuid = (): string => {
  const memberUuid = getCurrentMemberUuid();

  if (!memberUuid) {
    throw new Error('当前会话缺少 memberUuid，请先完成登录并刷新当前用户信息');
  }

  return memberUuid;
};

export const hasCurrentMemberUuid = (): boolean => {
  return Boolean(getCurrentMemberUuid());
};
